import UILogger from 'common/utils/logger';
import { getPreSignedDocument } from 'services/document-service';
import { set as setInDb, get as getFromDb } from 'idb-keyval';
/**
 * \/v([0-9]*)\/([a-z_0-9]+)\.([.png|jpeg|jpg]+)
 * extract name and extension of a file from url (../v1/bg.png)
 * @param uri
 * @returns {name: string | null; extension: string | null, version: number|null}
 */
export const getAssetFileMetaFromUri = (
  uri: string | undefined | null,
): { name: string | null; extension: string | null; version?: number | null } => {
  if (uri) {
    // if (uri.lastIndexOf('+') >= 0) {
    uri = uri.replace(/([^a-zA-Z0-9/.\-:_]+)/g, '-');
    // }
    const regex = new RegExp('/([a-zA-Z0-9_\\-]+).([.png|jpeg|jpg|mp4]+)$');
    const splited = uri.split(regex);
    console.log('getAssetFileMetaFromUri', splited);
    const fileMeta = {
      name: splited[1],
      extension: splited[2],
      // version: parseInt(splited[1]),
    };

    return fileMeta;
  }
  return { name: null, extension: null, version: null };
};

export const isOfTypeImage = (type?: string) => {
  return type?.startsWith('image') || false;
};

export const getImageTypeFromUri = (type: string) => {
  if (type.endsWith('jpg')) return 'image/jpg';
  if (type.endsWith('jpeg')) return 'image/jpeg';
  if (type.endsWith('png')) return 'image/png';
  return 'image/jpg';
};

export const getReadableFileSize = (fileSize: number) => {
  const fSExt = new Array('Bytes', 'KB', 'MB', 'GB');
  let i = 0;
  while (fileSize > 900) {
    fileSize /= 1024;
    i++;
  }
  var exactSize = Math.round(fileSize * 100) / 100 + ' ' + fSExt[i];
  return exactSize;
};

export const getFileNameFromUrl = (url: string = '') => {
  const s3FileName = url.split('/').pop();
  const filename = s3FileName?.substring(s3FileName.indexOf('-') + 1);
  console.log('getFileNameFromUrl::', filename);

  return filename;
};

export const getCachedAsset = async (
  assetUrl: string,
  cacheName: string = 'image-assets-cache',
  signingRequired?: boolean,
): Promise<any | undefined> => {
  //check if cache is available.
  let cachedResponse,
    cacheAvailable = typeof window !== 'undefined' && 'caches' in window;
  console.log('[AssetDownloader] Checking cache for:', assetUrl, 'cacheAvailable:', cacheAvailable);
  if (cacheAvailable) {
    const cache = await caches.open(cacheName);
    cachedResponse = await cache.match(assetUrl);
    if (cachedResponse) {
      console.log('[AssetDownloader] Image already cached.');
      return cachedResponse.clone(); // Still fetches from cache due to service worker/browser logic
    }
  } else {
    cachedResponse = await getFromDb(assetUrl);
    if (cachedResponse) {
      return new Response(cachedResponse);
    }
  }

  return downloadAsset(assetUrl, cacheName, cacheAvailable, signingRequired);
};

const downloadAsset = async (
  assetUrl: string,
  cacheName: string = 'image-assets-cache',
  cacheAvailable: boolean,
  signingRequired?: boolean,
): Promise<string | undefined> => {
  try {
    const originalUrl = assetUrl;
    console.log('[AssetDownloader] Downloading:', assetUrl);
    if (signingRequired) {
      assetUrl = await getPreSignedDocument(assetUrl); // Simulate as needed
    }

    const response = await fetch(assetUrl);
    if (!response.ok) throw new Error('Download failed: ' + response.status);

    if (cacheAvailable) {
      const cache = await caches.open(cacheName);
      await cache.put(originalUrl, response.clone());
    } else {
      const blob = await response.blob();
      setInDb(originalUrl, blob);
    }
    console.log('[AssetDownloader] Cached successfully.');
    return assetUrl; // You can use this directly in <img src={assetUrl} />
  } catch (err) {
    console.error('[AssetDownloader] Download error:', err);
    return undefined;
  }
};
